export enum LabelByStatus {
  active = 'Active',
  approved = 'Invited',
  pending_approval = 'Staged',
  blocked = 'Blocked',
}
